<template>
  <div class="container-fluid cards-pf full-height">
    <div class="row row-cards-pf">
      <div class="col-xs-12">
        <div class="card-pf">
          <div class="card-pf-heading">
            <h2 class="card-pf-title">ร่างแบบขออนุมัติงบประมาณและจัดโครงการ</h2>
          </div>
          <div class="card-pf-body">
            <form action="/" class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-3 text-left control-label required-field">1. ชื่อโครงการ</label>
                <div class="col-sm-9">
                  <input v-model="name" type="text" class="form-control">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 text-left control-label required-field">2. หน่วยงานที่รับผิดชอบ</label>
                <div class="col-sm-9">
                  <!-- <input type="text" class="form-control" value="a"> -->
                  <select v-model="group" class="form-control">
                    <option v-for="groupOption in groupOptions" :key="groupOption._id" :value="groupOption._id">{{ groupOption.name }}</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 text-left control-label required-field">3. ประธานโครงการ</label>
                <div class="col-sm-9">
                  <div class="row">
                    <div class="col-sm-5">
                      <input type="text" class="form-control">
                    </div>
                    <div class="col-sm-1 text-right">
                      <label class="text-left control-label required-field">โทร.</label>
                    </div>
                    <div class="col-sm-6">
                      <input v-model="responsiblePerson.tel" type="text" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 text-left control-label required-field">4. ผู้ประสานงาน</label>
                <div class="col-sm-9">
                  <div class="row">
                    <div class="col-sm-5">
                      <input v-model="responsiblePerson.name" type="text" class="form-control">
                    </div>
                    <div class="col-sm-1 text-right">
                      <label class="text-left control-label required-field">โทร.</label>
                    </div>
                    <div class="col-sm-4">
                      <input v-model="responsiblePerson.tel" type="text" class="form-control">
                    </div>
                    <div class="col-sm-2">
                      <button class="btn btn-primary btn-block">+</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 text-left control-label required-field">5. ที่ปรึกษา</label>
                <div class="col-sm-9">
                  <div class="row">
                    <div class="col-sm-5">
                      <input type="text" class="form-control">
                    </div>
                    <div class="col-sm-1 text-right">
                      <label class="text-left control-label required-field">โทร.</label>
                    </div>
                    <div class="col-sm-6">
                      <input type="text" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 text-left control-label required-field">6. หลักการและเหตุผล</label>
                <div class="col-sm-9">
                  <textarea v-model="background" rows="5" class="form-control" />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 text-left control-label required-field">7. วัตถุประสงค์</label>
                <div class="col-sm-9">
                  <textarea v-model="objectives" rows="5" class="form-control" />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 text-left control-label required-field">8. แผนการดำเนินงาน</label>
                <div class="col-sm-9">
                  <div class="form-group">
                    <label class="col-sm-3 text-left control-label required-field">ชื่อกิจกรรมที่ 1</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control">
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-3 text-left control-label required-field">ช่วงเวลา</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control">
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-3 text-left control-label required-field">ผู้รับผิดชอบ</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control">
                    </div>
                  </div>
                  <button class="btn btn-block btn-default">เพิ่มกิจกรรม</button>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 text-left control-label required-field">9. สถานที่จัดโครงการ</label>
                <div class="col-sm-9">
                  <input v-model="venue" type="text" class="form-control">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 text-left control-label required-field">10. ระยะเวลาปฏิบัติงาน</label>
                <div class="col-sm-9">
                  <input v-model="venue" type="text" class="form-control">
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-3 text-left control-label">11. ผู้เข้าร่วมโครงการ</label>
                <div class="col-sm-9">
                  <div class="row">
                    <div class="col-xs-4">
                      <div>
                        <div class="input-group">
                          <span class="input-group-addon">อาจารย์</span>
                          <input v-model="attendee.instructor" type="number" value="0" min="0" class="form-control">
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-4">
                      <div>
                        <div class="input-group">
                          <span class="input-group-addon">นักศึกษา</span>
                          <input v-model="attendee.student" type="number" value="0" min="0" required="required" class="form-control">
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-4">
                      <div>
                        <div class="input-group">
                          <span class="input-group-addon">บุคลากรภายนอก</span>
                          <input v-model="attendee.individual" type="number" value="0" min="0" required="required" class="form-control">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 text-left control-label">12. รายละเอียดงบประมาณ</label>
                <div class="col-sm-9">
                  <strong>แหล่งเงินภายใน</strong>
                  <div class="form-group" style="padding-left: 20px">
                    <label class="col-sm-5 text-left control-label required-field">เงินสนับสนุนกิจกรรมนักศึกษา</label>
                    <div class="col-sm-7">
                      <input v-model="venue" type="text" class="form-control">
                    </div>
                  </div>
                  <div class="form-group" style="padding-left: 20px">
                    <label class="col-sm-5 text-left control-label required-field">งบสำรองจ่าย</label>
                    <div class="col-sm-7">
                      <input v-model="venue" type="text" class="form-control">
                    </div>
                  </div>
                  <div class="checkbox" style="padding-left: 20px">
                    <label>
                      <input type="checkbox"> <strong>ไม่ใช้งบสนับสนุนกิจกรรมนักศึกษา</strong>
                    </label>
                  </div>
                  <div class="form-group" style="padding-left: 20px">
                    <label class="col-sm-5 text-left control-label required-field">งบอื่นๆ</label>
                    <div class="col-sm-7">
                      <input v-model="venue" type="text" class="form-control">
                    </div>
                  </div>
                  <strong>แหล่งเงินภายนอก</strong>
                  <div class="form-group" style="padding-left: 20px">
                    <label class="col-sm-5 text-left control-label required-field">งบสนับสนุนจากบริษัท/บุคคล</label>
                    <div class="col-sm-7">
                      <input v-model="venue" type="text" class="form-control">
                    </div>
                  </div>

                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>หมวดเงิน/รายการ</th>
                        <th>จำนวนหน่วย</th>
                        <th>หน่วยนับ</th>
                        <th>ระยะเวลา</th>
                        <th>หน่วยนับ</th>
                        <th>จำนวนเงินต่อหน่วย</th>
                        <th>จำนวน</th>
                        <th>หน่วยนับ</th>
                        <th>รวมเงิน (บาท)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colspan="9"><strong>หมวดค่าใช้สอย</strong></td>
                      </tr>
                      <tr>
                        <td>ค่าอาหาร อาหารว่าง เครื่องดื่ม</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าจ้างเหมาบริการต่างๆ</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าที่พัก</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าจัดพิมพ์</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td colspan="9"><strong>หมวดค่าตอบแทน</strong></td>
                      </tr>
                      <tr>
                        <td>ค่าตอบแทนวิทยากร</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าสอนผู้ฝึกสอนชมรมกีฬา</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าตอบแทนอาจารย์ที่ปรึกษาชมรม</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าตอบแทนนายแพทย์</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าตอบแทนการจ้างพยาบาล</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าตอบแทนนักศึกษาช่วยปฏิบัติงาน</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าตอบแทนอื่นๆ</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td colspan="9"><strong>หมวดวัสดุ</strong></td>
                      </tr>
                      <tr>
                        <td>ค่าวัสดุสำนักงาน</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าวัสดุโฆษณาประชาสัมพันธ์</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าวัสดุก่อสร้างและประปา</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าวัสดุน้ำมันเชื้อเพลิง</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าวัสดุงานบ้านงานครัว</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าวัสดุกีฬาและชมรมต่างๆ</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าวัสดุคอมพิวเตอร์และอิเล็กทรอนิกส์</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าวัสดุหนังสือ วารสาร และตำรา</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าวัสดุไฟฟ้า</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าวัสดุการเกษตร</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าวัสดุแต่งกาย</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td>ค่าวัสดุอื่นๆ</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td colspan="9"><strong>หมวดเงินบริจาค</strong></td>
                      </tr>
                      <tr>
                        <td>บริจาคเป็นเงิน</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <td colspan="9"><strong>หมวดค่าตอบแทน</strong></td>
                      </tr>
                      <tr>
                        <td>บริจาคเป็นสิ่งของ</td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                        <td style="vertical-align: middle;"><input type="text" class="form-control text-center"></td>
                      </tr>
                      <tr>
                        <th colspan="8" class="text-center">รวมเป็นเงิน (จำนวนเงินเป็นตัวอักษร)</th>
                        <th class="text-center">0.00</th>
                      </tr>
                    </tbody>
                  </table>
                  <strong>งบประมาณ</strong>
                  <ol>
                    <li>เงินสนับสนุนกิจกรรมนักศึกษา 0.00 บาท</li>
                    <li>เงินสำรองจ่าย 0.00 บาท</li>
                    <li>งบอื่นๆ 0.00 บาท</li>
                    <li>เงิน/ของบริจาค จากบริษัท/บุคคล 0.00 บาท</li>
                  </ol>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 text-left control-label required-field">13. เป้าหมาย/ตัวชี้วัดความสำเร็จ</label>
                <div class="col-sm-9">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th rowspan="2">ที่</th>
                        <th rowspan="2">กิจกรรม</th>
                        <th rowspan="2">กลุ่มเป้าหมาย</th>
                        <th colspan="2">งบประมาณ</th>
                        <th colspan="2">เป้าหมาย</th>
                      </tr>
                      <tr>
                        <th>แผน</th>
                        <th>ผล</th>
                        <th>แผน</th>
                        <th>ผล</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>โครงการ</td>
                        <td />
                        <td />
                        <td />
                        <td />
                        <td />
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>โครงการ</td>
                        <td />
                        <td />
                        <td />
                        <td />
                        <td />
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>โครงการ</td>
                        <td />
                        <td />
                        <td />
                        <td />
                        <td />
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 text-left control-label required-field">14. ประเภทกิจกรรม</label>
                <div class="col-sm-8">
                  <div class="radio">
                    <label>
                      <input v-model="type" type="radio" name="type" value="ด้านวิชาการ" required="">
                      ด้านวิชาการ
                    </label>
                  </div>
                  <div class="radio">
                    <label>
                      <input v-model="type" type="radio" name="type" value="ด้านกีฬาและนันทนาการ" required="">
                      ด้านกีฬาและนันทนาการ
                    </label>
                  </div>
                  <div class="radio">
                    <label>
                      <input v-model="type" type="radio" name="type" value="ด้านคุณธรรมจริยธรรม" required="">
                      ด้านคุณธรรมจริยธรรม
                    </label>
                  </div>
                  <div class="radio">
                    <label>
                      <input v-model="type" type="radio" name="type" value="ด้านส่งเสริมศิลปวัฒนธรรม" required="">
                      ด้านส่งเสริมศิลปวัฒนธรรม
                    </label>
                  </div>
                  <div class="radio">
                    <label>
                      <input v-model="type" type="radio" name="type" value="ด้านบำเพ็ญประโยชน์ และรักษาสิ่งแวดล้อม" required="">
                      ด้านบำเพ็ญประโยชน์ และรักษาสิ่งแวดล้อม
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group-title">15. ลักษณะกิจกรรมที่บ่งชี้ถึงอัตลักษณ์สถาบัน</div>
              <div class="form-group">
                <label class="col-sm-3 text-left control-label required-field left-padded">ซื่อสัตย์</label>
                <div class="col-sm-8">
                  <input v-model="typeCharacteristics[0]" type="text" rows="3" class="form-control">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 text-left control-label required-field left-padded">ใฝ่รู้</label>
                <div class="col-sm-8">
                  <input v-model="typeCharacteristics[1]" type="text" rows="3" class="form-control">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 text-left control-label required-field left-padded">สู้งาน</label>
                <div class="col-sm-8">
                  <input v-model="typeCharacteristics[2]" type="text" rows="3" class="form-control">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 text-left control-label required-field">16. ทักษะ</label>
                <div class="col-sm-8">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" name="type" value="ด้านวิชาการ" required="">
                      การทำงานร่วมกัน
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" name="type" value="ด้านกีฬาและนันทนาการ" required="">
                      ภาวะผู้นำและความรับผิดชอบ
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" name="type" value="ด้านคุณธรรมจริยธรรม" required="">
                      การใช้เทคโนโลยี
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" name="type" value="ด้านส่งเสริมศิลปวัฒนธรรม" required="">
                      ทักษะการใช้ภาษาต่างชาติ
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" name="type" value="ด้านบำเพ็ญประโยชน์ และรักษาสิ่งแวดล้อม" required="">
                      ความสามารถในการแก้ไขปัญหา
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" name="type" value="ด้านบำเพ็ญประโยชน์ และรักษาสิ่งแวดล้อม" required="">
                      ความคิดสร้างสรรค์
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" name="type" value="ด้านบำเพ็ญประโยชน์ และรักษาสิ่งแวดล้อม" required="">
                      การประสานและสื่อสารระหว่างบุคคลหรือองค์กร
                    </label>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  apollo: {
    user: {
      query: gql`query user($id: ID!){
        user(_id: $id) {
          firstName
          lastName
          groups {
            _id
            name
            advisorName
          }
        }
      }`,
      variables () {
        return {
          id: this.$auth.user().id
        }
      }
    }
  },
  data () {
    return {
      name: '',
      type: '',
      group: '',
      typeCharacteristics: ['', '', ''],
      venue: '',
      attendee: {
        instructor: '',
        student: '',
        individual: '',
        others: ''
      },
      advisor: {
        name: '',
        tel: ''
      },
      heldOn: '',
      aspectAndGoal: '',
      objectives: '',
      background: '',
      responsiblePerson: {
        name: '',
        tel: ''
      },
      budget: {
        osda: '',
        other: '',
        sponsors: ''
      },
      procedures: '',
      expectedOutcome: '',
      plannedBudget: {
        meal: '',
        accommodation: '',
        materials: '',
        transportation: '',
        gas: '',
        vehicleRental: '',
        tollwayFee: '',
        driver: '',
        lecture: '',
        other: ''
      },
      sponsoredMaterials: ''
    }
  },
  computed: {
    groupOptions () {
      if (this.user) {
        return this.user.groups
      }

      return []
    }
  },
  watch: {
    user (newValue) {
      this.responsiblePerson.name = newValue.firstName + ' ' + newValue.lastName
      this.group = newValue.groups[0]._id
      this.advisor.name = newValue.groups[0].advisorName
    },
    group (newValue) {
      this.advisor.name = this.user.groups.filter(group => group._id === newValue)[0].advisorName
    }
  },
  methods: {
    async submit () {
      const proposal = await this.$apollo.mutate({
        mutation: gql`mutation ($proposal: CreateProjectProposalInput!) {
          createProjectProposal(proposal: $proposal) {
              _id
            }
          }`,
        variables: {
          proposal: {
            name: this.name,
            group: this.group,
            type: this.type,
            typeCharacteristics: [this.typeCharacteristics[0], this.typeCharacteristics[1], this.typeCharacteristics[2]],
            responsiblePerson: {
              name: this.responsiblePerson.name,
              tel: this.responsiblePerson.tel
            },
            advisor: {
              name: this.advisor.name,
              tel: this.advisor.tel
            },
            background: this.background,
            objectives: this.objectives,
            aspectAndGoal: this.aspectAndGoal,
            venue: this.venue,
            heldOn: this.heldOn,
            attendee: {
              instructor: parseInt(this.attendee.instructor),
              student: parseInt(this.attendee.student),
              individual: parseInt(this.attendee.individual),
              others: parseInt(this.attendee.others)
            },
            procedures: this.procedures,
            expectedOutcome: this.expectedOutcome,
            budget: {
              osda: parseFloat(this.budget.osda),
              other: parseFloat(this.budget.other),
              sponsors: parseFloat(this.budget.sponsors)
            },
            plannedBudget: {
              meal: parseFloat(this.plannedBudget.meal),
              accommodation: parseFloat(this.plannedBudget.accommodation),
              materials: parseFloat(this.plannedBudget.materials),
              transportation: parseFloat(this.plannedBudget.transportation),
              gas: parseFloat(this.plannedBudget.gas),
              vehicleRental: parseFloat(this.plannedBudget.vehicleRental),
              tollwayFee: parseFloat(this.plannedBudget.tollwayFee),
              driver: parseFloat(this.plannedBudget.driver),
              lecture: parseFloat(this.plannedBudget.lecture),
              other: parseFloat(this.plannedBudget.other)
            },
            sponsoredMaterials: this.sponsoredMaterials
          }
        }
      })

      // TODO: Implement toast notification

      this.$router.push({ name: 'projects.show', params: { id: proposal.data.createProjectProposal._id } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/js/views/projects/Create.vue